import React, { useState, useEffect } from "react";
import {
    Typography,
    Box,
    Grid,
    Avatar,
    IconButton,
} from '@mui/material';
import PhoneIcon from "@mui/icons-material/Phone";
import { User, MapPin, Calendar, Newspaper } from "lucide-react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const PersonContact = ({ data, contacts }) => {

    // Convert phone number to international format (MY example)
    const formatPhoneNumber = (phone) => {
        if (!phone) return "";
        // remove spaces & symbols
        let cleaned = phone.replace(/\D/g, "");
        // if starts with 0 → Malaysia +60
        if (cleaned.startsWith("0")) {
            cleaned = "60" + cleaned.substring(1);
        }
        return cleaned;
    };

    const handleCall = (phone) => {
        if (!phone) return;
        window.location.href = `tel:${phone}`;
    };

    const handleWhatsApp = (phone) => {
        if (!phone) return;
        const formatted = formatPhoneNumber(phone);
        window.open(`https://wa.me/${formatted}`, "_blank");
    };

    return (<div style={{ fontFamily: data.fontStyle, textAlign: 'start', width: "300px" }}>

        <Box sx={{ mt: 0, px: 2, pt: 3, pb: 3, border: '1px solid #ddd', borderRadius: '20px', backdropFilter: "blur(3px)", background: "rgba(255, 255, 255, 0.85)" }}>

            {contacts?.map((p, index) => (

                <Grid
                    key={index}
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                        mt: 2,
                        background: "#f3f3f3ff",
                        borderRadius: "20px",
                        p: 1.5,
                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                    }}
                >
                    {/* Left side - Avatar + Name */}
                    <Grid item sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0, flex: 1, mr: 1 }}>
                        <User size={30} style={{ backgroundColor: data?.buttonColour || data?.themeColour, color: "white", borderRadius: "50px", padding: "4px", flexShrink: 0 }} />
                        <Box sx={{ minWidth: 0 }}>
                            <Typography title={p.contactName} sx={{ fontWeight: 600, fontSize: "12px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {p.contactName}
                            </Typography>
                            {p.relationship && (
                                <Typography title={p.relationship} variant="body2" sx={{ color: "#888", fontSize: p.relationship.length > 20 ? "11px" : "12px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    ({p.relationship})
                                </Typography>
                            )}
                        </Box>
                    </Grid>

                    {/* Right side - Icons */}
                    <Grid item sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
                        <IconButton
                            onClick={() => handleCall(p.contactPhoneNum)}
                            sx={{
                                width: 30,
                                height: 30,
                                background: data?.buttonColour || data?.themeColour,
                                color: "#fff",
                                "&:hover": {
                                    background: data?.buttonColour || data?.themeColour,
                                    opacity: 0.9
                                },
                                "&:active": {
                                    background: data?.buttonColour || data?.themeColour,
                                    opacity: 0.8
                                }
                            }}
                        >
                            <PhoneIcon sx={{ fontSize: 19 }} />
                        </IconButton>
                        <IconButton
                            onClick={() => handleWhatsApp(p.contactPhoneNum)}
                            sx={{
                                width: 30,
                                height: 30,
                                background: data?.buttonColour || data?.themeColour,
                                color: "#fff",
                                "&:hover": {
                                    background: data?.buttonColour || data?.themeColour,
                                    opacity: 0.9
                                },
                                "&:active": {
                                    background: data?.buttonColour || data?.themeColour,
                                    opacity: 0.8
                                }
                            }}
                        >
                            <WhatsAppIcon fontSize="small" />
                        </IconButton>
                    </Grid>

                </Grid>
            ))}
        </Box>

    </div>


    )
};

export default PersonContact